import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMarks } from '../../redux/action/studentAction';
import HomeHelper from '../../Components/HomeHelper';
import { useHistory } from 'react-router-dom';
import Footer from '../../Components/Footer';
import '../../Style/StuResult.css';
import Loading from '../../Components/Loading';
const StudentResult = () => {
    const store = useSelector(store => store);
    const history = useHistory();
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(getMarks())
   },[])
   const isResultDataAvailable = store.student.allMarks.CycleTest1 && store.student.allMarks.CycleTest1.length > 0;
    return (
        <>
        <HomeHelper />
        {store.student.isAuthenticated ? (
                    <>

                <div className="container-fluid main"  style={{ backgroundImage: 'url("/image/pattern.png")', backgroundRepeat: 'repeat' }}>
                <div className='px-4 py-1 bg-light d-flex align-items-center justify-content-between'>
                            <h3 className='d-flex align-items-center justify-content-between'> <img src="/logo192.png" width={'40px'} alt="" /> Result</h3>
                            <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                        </div>
                {isResultDataAvailable ? (
                   <div>
                         {store.student.allMarks.CycleTest1 &&
                        <div className="row mt-3 ">
                            <div className="col-md-8 m-auto resultT">
                                {store.student.allMarks.CycleTest1.length !== 0 ? <>
                                    <h3 className='text-center mt-3'>Result for Cycle Test 1 Examination</h3>
                                    <div className="stuDetails mt-3">
                                        <h5>Register Number : {store.student.student.student.registrationNumber}</h5>
                                        <h5>NAME : {store.student.student.student.name}</h5>
                                        <h5>Branch : {store.student.student.student.branch}</h5>
                                    </div>
                                    <table className="table resultT table-responsive table-striped table-bordered">
                                        <thead>
                                            <tr className="table resultTcol text-light">
                                            <th scope="col" width="10%">S.No</th>
                                                <th scope="col" width="20%">Subject Code</th>
                                                <th scope="col" width="40%">Subject Name</th>
                                                <th scope="col" width="10%">Obtained Marks</th>
                                                <th scope="col" width="10%">Total Marks</th>
                                                <th scope="col" width="10%">Result</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                store.student.allMarks.CycleTest1.map((res, index) =>
                                                    <tr key={index}>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{res.subject.subjectCode}</td>
                                                        <td>{res.subject.subjectName}</td>
                                                        <td>{res.marks}</td>
                                                        <td>{res.totalMarks}</td>
                                                        <td>{res.marks < 45 ? "Fail" : "Pass"}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                      
                                    </> : null}
                            </div>
                        </div>


                    }

                    {store.student.allMarks.CycleTest2 &&
                        <div className="row mt-3">
                            <div className="col-md-8 m-auto resultT">
                                {store.student.allMarks.CycleTest2.length !== 0 ? <>
                                    <h3 className='text-center mt-3'>Result for Cycle Test 2 Examination</h3>
                                    <div className="stuDetails mt-3">
                                        <h5>Register Number : {store.student.student.student.registrationNumber}</h5>
                                        <h5>NAME : {store.student.student.student.name}</h5>
                                        <h5>Branch : {store.student.student.student.branch}</h5>
                                    </div>
                                    <table className="table resultT table-responsive table-striped table-bordered">
                                        <thead>
                                            <tr className="table resultTcol text-light">
                                                <th scope="col" width="10%">S.No</th>
                                                <th scope="col" width="20%">Subject Code</th>
                                                <th scope="col" width="40%">Subject Name</th>
                                                <th scope="col" width="10%">Obtained Marks</th>
                                                <th scope="col" width="10%">Total Marks</th>
                                                <th scope="col" width="10%">Result</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                store.student.allMarks.CycleTest2.map((res, index) =>
                                                    <tr key={index}>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{res.subject.subjectCode}</td>
                                                        <td>{res.subject.subjectName}</td>
                                                        <td>{res.marks}</td>
                                                        <td>{res.totalMarks}</td>
                                                        <td>{res.marks < 45 ? "Fail" : "Pass"}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table></> : null}
                            </div>
                        </div>
                    }

                    {store.student.allMarks.Semester &&
                        <div className="row mt-3 ">
                            <div className="col-md-8 m-auto resultT">
                                {store.student.allMarks.Semester.length !== 0 ? <>
                                    <h3 className='text-center mt-3'>Result for Model Examination</h3>
                                    <div className="stuDetails mt-3">
                                        <h5>Register Number : {store.student.student.student.registrationNumber}</h5>
                                        <h5>NAME : {store.student.student.student.name}</h5>
                                        <h5>Branch : {store.student.student.student.branch}</h5>
                                    </div>
                                    <table className="table resultT table-responsive table-striped table-bordered">
                                        <thead>
                                            <tr className="table resultTcol text-light">
                                            <th scope="col" width="10%">S.No</th>
                                                <th scope="col" width="20%">Subject Code</th>
                                                <th scope="col" width="40%">Subject Name</th>
                                                <th scope="col" width="10%">Obtained Marks</th>
                                                <th scope="col" width="10%">Total Marks</th>
                                                <th scope="col" width="10%">Result</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                store.student.allMarks.Semester.map((res, index) =>
                                                    <tr key={index}>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{res.subject.subjectCode}</td>
                                                        <td>{res.subject.subjectName}</td>
                                                        <td>{res.marks}</td>
                                                        <td>{res.totalMarks}</td>
                                                        <td>{res.marks < 45 ? "Fail" : "Pass"}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table></> : null}
                            </div>
                        </div>


                    }
                   </div>
                    ) : (
                    <Loading />
                    )}
                </div></>
                ) : (
                    history.push('/')
                )
}
            <Footer />
        </>
    );
};

export default StudentResult;




